var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/helpers/toConsumableArray", "@babel/runtime-corejs2/core-js/parse-int"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/helpers/toConsumableArray"), require("@babel/runtime-corejs2/core-js/parse-int"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.toConsumableArray, global.parseInt);
    global.sliderHelpers = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _toConsumableArray2, _parseInt2) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.checkSliderVisibility = _exports.isVisible = _exports.getTranslateWidth = _exports.getSlidesWidth = _exports.getSlideWidth = _exports.DEBOUNCE_RESIZE = _exports.DEBOUNCE_SCROLL = void 0;
  _toConsumableArray2 = _interopRequireDefault(_toConsumableArray2);
  _parseInt2 = _interopRequireDefault(_parseInt2);
  var DEBOUNCE_SCROLL = 10;
  _exports.DEBOUNCE_SCROLL = DEBOUNCE_SCROLL;
  var DEBOUNCE_RESIZE = 200;
  _exports.DEBOUNCE_RESIZE = DEBOUNCE_RESIZE;

  var getSlideWidth = function getSlideWidth(element) {
    var style = global.getComputedStyle ? global.getComputedStyle(element, null) : element.currentStyle;
    var marginLeft = (0, _parseInt2.default)(style.marginLeft, 10) || 0;
    var marginRight = (0, _parseInt2.default)(style.marginRight, 10) || 0;
    return element.offsetWidth + marginLeft + marginRight;
  };

  _exports.getSlideWidth = getSlideWidth;

  var getSlidesWidth = function getSlidesWidth(element, selector) {
    var visibleWidth = 0;
    (0, _toConsumableArray2.default)(element.querySelectorAll(selector)).forEach(function (slide) {
      var slideWidth = getSlideWidth(slide);
      visibleWidth += slideWidth;
    });
    return visibleWidth;
  };

  _exports.getSlidesWidth = getSlidesWidth;

  var getTranslateWidth = function getTranslateWidth(element, selector) {
    var translateX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var visibleWidth = 0;
    var remainingScroll = element.scrollWidth - element.offsetWidth - translateX;
    (0, _toConsumableArray2.default)(element.querySelectorAll(selector)).forEach(function (slide) {
      var slideWidth = getSlideWidth(slide);

      if (slide.offsetLeft + slideWidth <= element.scrollLeft + element.offsetWidth + translateX && visibleWidth - translateX <= remainingScroll) {
        visibleWidth += slideWidth;
      }
    });
    return visibleWidth - translateX;
  };

  _exports.getTranslateWidth = getTranslateWidth;

  var isVisible = function isVisible(slider) {
    if (slider) {
      var sliderHeight = slider.offsetHeight;
      var visible = slider.getBoundingClientRect().top > -sliderHeight && slider.getBoundingClientRect().top < global.innerHeight + sliderHeight;
      return visible;
    }

    return false;
  };

  _exports.isVisible = isVisible;

  var checkSliderVisibility = function checkSliderVisibility(callback, slider) {
    var visible = isVisible(slider);

    if (visible) {
      callback({
        visible: visible
      });
    }
  };

  _exports.checkSliderVisibility = checkSliderVisibility;
});